import React, { Fragment } from "react"
import Studio from "features/studio/Studio"
import WithRecord from "data/wrappers/WithRecord"
import WithObject from "data/wrappers/WithObject"
import AttributeList from "features/records/components/AttributeList"
import { PageTitle, Breadcrumbs, Card, Container } from "ui"

export default class RecordDetailPage extends React.Component {
    render() {
        return (
            <Studio>
                <WithRecord recordId={this.props.params.recordId}>
                    {({ record, onChange }) => (
                        <WithObject objectId={record._object_id}>
                            {({ object, primaryField }) => {
                                let recordName = record[primaryField.api_name]
                                return (
                                    <Fragment>
                                        <Breadcrumbs
                                            crumbs={[
                                                { label: "Data", link: "/data" },
                                                { label: "Tables", link: "/tables" },
                                                {
                                                    label: object.name,
                                                    link: "/table/" + object._sid,
                                                },
                                                { label: "Records", link: "/table/" + object._sid + "/records" },
                                            ]}
                                        />
                                        <PageTitle>{recordName}</PageTitle>
                                        <Card>
                                            <Container wrapItems>
                                                <AttributeList
                                                    editable
                                                    data={record}
                                                    onChange={onChange}
                                                    fields={object.fields}
                                                />
                                            </Container>
                                        </Card>
                                    </Fragment>
                                )
                            }}
                        </WithObject>
                    )}
                </WithRecord>
            </Studio>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/studio/containers/RecordDetailPage.js